import { render, staticRenderFns } from "./reportform.vue?vue&type=template&id=36b2a03f&scoped=true&"
import script from "./reportform.vue?vue&type=script&lang=js&"
export * from "./reportform.vue?vue&type=script&lang=js&"
import style0 from "./reportform.vue?vue&type=style&index=0&id=36b2a03f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2a03f",
  null
  
)

export default component.exports